import ContactPageContent from '@/components/pages/contact-page';

export default function ContactPage() {
  return <ContactPageContent />;
}
